
import { Link } from 'react-router-dom';

export default function InvestimentoSection() {
  const inclusoes = [
    '10 encontros ao vivo de 4 horas',
    'Acesso a todas as gravações',
    'Ferramentas práticas exclusivas',
    'Suporte via WhatsApp',
    'Certificado de conclusão',
    'Comunidade exclusiva',
    'Material complementar',
    'Reposição de encontros'
  ];

  return (
    <section id="investimento" className="py-24 bg-gradient-to-br from-purple-900 via-purple-800 to-purple-700 relative overflow-hidden">
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-20 left-20 w-96 h-96 bg-gold-500 rounded-full blur-3xl"></div>
        <div className="absolute bottom-20 right-20 w-96 h-96 bg-pink-500 rounded-full blur-3xl"></div>
      </div>

      <div className="relative z-10 max-w-6xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <div className="inline-block bg-white/20 text-white px-6 py-2 rounded-full text-sm font-semibold uppercase tracking-wider mb-6">
            Investimento
          </div>
          <h2 className="font-display text-5xl lg:text-6xl font-bold text-white mb-6">
            Transforme sua liderança agora
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12">
          <div className="bg-white rounded-3xl p-10 shadow-2xl relative">
            <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-gold-500 text-purple-900 px-6 py-2 rounded-full text-sm font-bold whitespace-nowrap">
              Mais escolhido
            </div>
            <div className="text-center mb-8">
              <p className="text-gray-600 text-sm mb-2">Parcelado em</p>
              <p className="font-display text-6xl font-bold text-purple-900 mb-2">
                12x R$294
              </p>
              <p className="text-gray-500 text-sm">Total: R$3.528</p>
            </div>
            <ul className="space-y-4 mb-8">
              {inclusoes.map((item, index) => (
                <li key={index} className="flex items-start space-x-3">
                  <div className="w-6 h-6 flex items-center justify-center flex-shrink-0">
                    <i className="ri-check-line text-gold-500 text-xl"></i>
                  </div>
                  <span className="text-gray-700">{item}</span>
                </li>
              ))}
            </ul>
            <Link
              to="/inscricao"
              className="block w-full bg-gold-500 text-purple-900 py-5 rounded-full text-lg font-bold hover:bg-gold-400 transition-all hover:scale-105 shadow-lg text-center whitespace-nowrap"
            >
              Começar agora
            </Link>
          </div>

          <div className="bg-white rounded-3xl p-10 shadow-2xl">
            <div className="text-center mb-8">
              <p className="text-gray-600 text-sm mb-2">Pagamento à vista</p>
              <p className="font-display text-5xl font-bold text-purple-900 mb-2">
                R$2.890
              </p>
              <div className="inline-block bg-green-100 text-green-700 px-4 py-1 rounded-full text-sm font-bold">
                Economize R$638
              </div>
            </div>
            <ul className="space-y-4 mb-8">
              {inclusoes.map((item, index) => (
                <li key={index} className="flex items-start space-x-3">
                  <div className="w-6 h-6 flex items-center justify-center flex-shrink-0">
                    <i className="ri-check-line text-gold-500 text-xl"></i>
                  </div>
                  <span className="text-gray-700">{item}</span>
                </li>
              ))}
            </ul>
            <Link
              to="/inscricao"
              className="block w-full border-2 border-gold-500 text-gold-600 py-5 rounded-full text-lg font-bold hover:bg-gold-500 hover:text-purple-900 transition-all hover:scale-105 text-center whitespace-nowrap"
            >
              Começar agora
            </Link>
          </div>
        </div>

        <div className="text-center">
          <p className="text-white/90 text-lg mb-6">
            Dúvidas sobre o investimento? Fale com nossa equipe
          </p>
          <a
            href="https://wa.me/5511999999999"
            className="inline-flex items-center space-x-2 text-gold-400 hover:text-gold-300 transition-colors font-semibold"
          >
            <i className="ri-whatsapp-line text-2xl"></i>
            <span>(11) 99999-9999</span>
          </a>
        </div>
      </div>
    </section>
  );
}
